import { memo, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import {
  CallReceivedIcon,
  CallSharedIcon,
  MagnifyingGlassIcon,
  PhoneIcon,
  SMSIcon,
  SMSReceivedIcon,
  SMSSharedIcon,
  LandlineIcon,
  SmartphoneIcon,
  VOIPIcon,
  MarkerIcon,
} from '@rsos/assets/icons';
import { CALL_REROUTED } from '@rsos/constants/collaborator';
import {
  VOIP,
  PHASE,
  TEXT,
  ALI_UNDERSCORE,
} from '@rsos/constants/locationTypes';

export const EmergencyCallIcons = props => {
  const theme = useContext(ThemeContext);
  const [iconType, setIconType] = useState('call');
  const {
    isPremiumUser,
    applicationType,
    classOfService,
    isAdmin,
    collaboratorType,
  } = props;

  const resolveCallIcon = () => {
    const isAniAli = applicationType?.startsWith(ALI_UNDERSCORE);
    if (isAdmin) return <SmartphoneIcon width={24} height={16} />;
    if (collaboratorType === CALL_REROUTED)
      return <MarkerIcon width={24} height={16} />;
    if (classOfService === TEXT) return <SMSIcon width={24} height={16} />;
    if (isPremiumUser) {
      if (
        isAniAli &&
        ((classOfService && !classOfService?.startsWith(PHASE)) ||
          !classOfService)
      ) {
        if (classOfService === VOIP) {
          return (
            <VOIPIcon
              width={24}
              height={16}
              viewboxWidth={16}
              viewboxHeight={16}
            />
          );
        }
        return <LandlineIcon width={24} height={16} />;
      }
      return <SmartphoneIcon width={24} height={16} />;
    }
    return (
      <PhoneIcon width={24} height={16} viewboxWidth={11} viewboxHeight={15} />
    );
  };

  const getIcons = type => {
    const iconUnseenColor = theme.colors.queue.emergencyCall.unseen;
    const icons = {
      call: resolveCallIcon(),
      callReceived: <CallReceivedIcon width={24} height={16} />,
      callReceivedUnseen: (
        <CallReceivedIcon width={24} height={16} color={iconUnseenColor} />
      ),
      callShared: <CallSharedIcon width={24} height={16} />,
      search: <MagnifyingGlassIcon width={24} height={16} />,
      sms: <SMSIcon width={24} height={16} />,
      smsReceived: <SMSReceivedIcon width={25} height={25} />,
      smsReceivedUnseen: (
        <SMSReceivedIcon width={25} height={25} color={iconUnseenColor} />
      ),
      smsShared: <SMSSharedIcon width={25} height={26} />,
    };

    return icons[type];
  };

  const checkIconType = status => {
    const {
      isManualSearch,
      isSMSReceived,
      isSMSShared,
      isSMS,
      isCallReceived,
      isCallShared,
      isUnseen,
    } = status;
    if (isManualSearch) return 'search';
    else if (isSMSReceived)
      return isUnseen ? 'smsReceivedUnseen' : 'smsReceived';
    else if (isSMSShared) return 'smsShared';
    else if (isCallReceived)
      return isUnseen ? 'callReceivedUnseen' : 'callReceived';
    else if (isCallShared) return 'callShared';
    else if (isSMS) return 'sms';
    else return 'call';
  };

  useEffect(() => {
    setIconType(checkIconType(props));
  }, [props]);

  return <>{getIcons(iconType)}</>;
};

EmergencyCallIcons.propTypes = {
  isManualSearch: PropTypes.bool,
  isCallReceived: PropTypes.bool,
  isCallShared: PropTypes.bool,
  isSMS: PropTypes.bool,
};

export default memo(EmergencyCallIcons);
